// extracted by mini-css-extract-plugin
export default {"container":"Waa-z","oos":"Xaa-z","oosUx":"Yaa-z","selected":"Zaa-z","labelOos":"_aa-z"};